// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","7938":"bcf1f101","9382":"bfb14e96"}[chunkId] + ".chunk.css";
};